import { formatCurrency } from "@/utils/currencyUtils";

interface LoanPaymentInfoProps {
  monthly_payment: number | null;
  next_payment_date: string | null;
}

export const LoanPaymentInfo = ({
  monthly_payment,
  next_payment_date
}: LoanPaymentInfoProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <p className="text-sm font-medium text-muted-foreground">Monthly Payment</p>
        <p className="text-sm mt-1">
          {monthly_payment ? formatCurrency(monthly_payment, "GHS") : 'N/A'}
        </p>
      </div>
      <div>
        <p className="text-sm font-medium text-muted-foreground">Next Payment</p>
        <p className="text-sm mt-1">
          {next_payment_date ? 
            new Date(next_payment_date).toLocaleDateString() : 
            'N/A'
          }
        </p>
      </div>
    </div>
  );
};